export default {
  page_title: '搜索帮助',
  t_operators: '使用搜寻运算符',
  t_precedence: '搜寻运算符优先级',
  operators: [
    '搜索运算符 （search operators） 为特别的搜索用词、以便更有效掌握你的搜索范围。 你可以于本网站顶部及首页搜寻字段中使用以下运算子。本部分暂时未有翻译，敬请注意。',
    '如果在同一项搜索中使用多于一个运算符，该项查询将用以下的顺序处理：'
  ],
}